export enum McfaClaimShipmentType {
    Emergency = "Emergency",
    Stock = "Stock",
}
